<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Informe de arqueo de caja</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button type="button" @click="mostrarHistoricos" class="btn-secondary">
            <i class="fa fa-history"></i><span>Historial</span>
          </button>
          <button type="button" @click="exportarDocumento('E')" class="btn-success">
            <i class="fa fa-file-excel-o"></i><span>Excel</span>
          </button>
          <button type="button" @click="exportarDocumento('P')" class="btn-danger">
            <i class="fa fa-file-pdf-o"></i><span>PDF</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">          
          <div class="col-xs-12 col-md-8">
            <div class="form-inline">
              <label>
                <input
                  v-model="form.tipoFecha"
                  type="radio"
                  value="H"
                />
                <span>Hoy</span>
              </label>
              <label>
                <input
                  v-model="form.tipoFecha"
                  type="radio"
                  value="A"
                />
                <span>Ayer</span>
              </label>
              <label>
                <input
                  v-model="form.tipoFecha"
                  type="radio"
                  value="P"
                />
                <span>Personalizado</span>
              </label>
              <div class="form-field" v-show="form.tipoFecha == 'P'">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="desde"
                    v-model="form.fechaDesde"
                    locale="es"
                    only-date
                    no-label
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione fecha..."
                  />
                  <label>Desde:</label>
                </div>
              </div>
              <div class="form-field" v-show="form.tipoFecha == 'P'">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="desde"
                    v-model="form.fechaHasta"
                    locale="es"
                    only-date
                    no-label
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione fecha..."
                  />
                  <label>Hasta:</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div 
              class="form-field select2 select2-field--stretch"
              :class="{'select2--disabled': !administraTodasBodegas}"
            >
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @input="inputBodega"
                  label="descripcion"
                  placeholder="Seleccione..."
                  :options="optionsBodegas"
                  id="bodegas"
                  v-model="selectedBodega"
                ></v-select>
                <label for="bodegas">Sucursal:</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-9">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @search="onSearchUsuarios"
                  @input="inputUsuarios"
                  label="nombre"
                  placeholder="Seleccione..."
                  :options="optionsUsuarios"
                  id="usuarios"
                  v-model="selectedUsuarios"
                  multiple
                ></v-select>
                <label for="usuarios">Recaudadores:</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="registros.length > 0">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-field">
              <h6>{{ ((nombreBodega != null && nombreBodega != '') ? `SUCURSAL: ${nombreBodega} | `:'') + 'Total: ' + total }}</h6>
            </div> 
          </div>
          <div class="col-xs-12">
            <div class="table-responsive">
              <vue-good-table
                :columns="columns"
                :pagination-options="{
                  enabled: true,
                  perPage: 15,
                  perPageDropdown: dropDown,
                  nextLabel: 'siguiente',
                  prevLabel: 'anterior',
                  rowsPerPageLabel: 'Registros por página',
                  ofLabel: 'de',
                  allLabel: 'Todo',
                  dropdownAllowAll: true
                }"
                :rows="registros"
                :search-options="{
                  enabled: true,
                  placeholder: 'Buscar...'
                }"
                styleClass="vgt-table vgt-table--sticky"
              >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'numero_cartilla'">
                  <span>
                    <button class="btn-info btn--text" type="button" @dblclick="verCartilla(props.row)"><span>{{props.formattedRow[props.column.field]}}</span></button>
                  </span> 
                </span>
                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      name="historicos"
      height="auto"
      width="70%"
      scrollable
      adaptive
      resizable
      reset
    >
      <reportes-historicos-excel
        tipoReporte='ac'
      ></reportes-historicos-excel>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    bodegas: {
      required: true
    },
    administraTodasBodegas: {
      type: Boolean,
      required: true
    },
    idBodegaUsuario: {
      required: true
    }
  },
  data: function() {
    return {
      columns: [
        {
          label: '#',
          field: 'numero_registro',
          filterable: false,
        },
        {
          label: 'Fecha',
          field: 'fecha_abono',
          filterable: false,
        },
        {
          label: '# Abono',
          field: 'numero_abono',
          filterable: false,
        },
        {
          label: '# Cartilla',
          field: 'numero_cartilla',
          filterable: false,
        },
        {
          label: 'Cliente',
          field: 'cliente',
          filterable: false,
        },
        {
          label: 'Zona',
          field: 'zona',
          filterable: false,
        },
        {
          label: 'Valor',
          field: 'valor',
          filterable: false,
        },
        {
          label: 'Recaudador',
          field: 'usuario',
          filterable: false,
        },
        {
          label: 'Fec. Creación',
          field: 'fecha_creacion',
          filterable: false,
        },
      ],
      registros: [],
      selectedUsuarios: [],
      optionsUsuarios: [],
      selectedBodega: null,
      nombreBodega: '',
      optionsBodegas: [],
      total: 0,
      form: {
        tipoFecha: 'P',
        fechaDesde: '',
        fechaHasta: '',
        idsUsuarios: [],
        idBodega: null, 
      }
    }
  },
  methods: {
    verCartilla: function (cartilla) {
      window.open(url + "/logistica/pedidos/" + cartilla.id + "/edit", "_blank");
    },
    onSearchUsuarios: function(search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.optionsUsuarios = json;
          loading(false);
        } 
        else 
          loading(false);
      };
      let urlApi = `${url}/search/usuarios?search=${search}&tipo=R`;
      xmlhttp.open("GET", urlApi, true);
      xmlhttp.send();
    },
    inputUsuarios: function() {
      this.form.idsUsuarios.splice(0, this.form.idsUsuarios.length);
      this.form.idsUsuarios = this.selectedUsuarios.map(usuario => usuario.id);
    },
    inputBodega: function() {
      this.form.idBodega = null;
      if(this.selectedBodega != null)
        this.form.idBodega = this.selectedBodega.id;
    },
    validandoFiltros: function() {
      //Validando las fechas
      if(this.form.tipoFecha == 'P'){
        if(this.form.fechaDesde == null || this.form.fechaHasta == null){
          swal('Aviso', 'Las fechas son requeridas', 'warning');
          return false;
        }
        let desde = new Date(this.form.fechaDesde + ' 00:00:00');
        let hasta = new Date(this.form.fechaHasta + ' 00:00:00');
        if(desde == "Invalid Date" || hasta == "Invalid Date"){
          swal('Aviso', 'Debe ingresar correctamente las fechas', 'warning');
          return false;
        }
      }
      return true;
    },
    exportarDocumento: function(tipo) {
      if(!this.validandoFiltros())
        return;
      let urlApi = `${url}/reporte-arqueo-caja/consultar/${tipo}${this.serialize(this.form)}`;
      window.open(urlApi, '_blank');
    },
    consultar: function() {
      if(!this.validandoFiltros())
        return;
      let urlApi = `${url}/reporte-arqueo-caja/consultar/C`;
      axios
        .post(urlApi, this.form)
        .then(response => {
          let data = response.data;
          this.nombreBodega = data.nombreBodega;
          this.total = data.total;
          this.registros.splice(0, this.registros.length);
          this.registros = [...data.registros];          
        })
        .catch(error => {
          swal('Error', 'No se pudo consultar el reporte', 'error');
        });
    },
    mostrarHistoricos: function () {
      this.$modal.show('historicos');
    },
    serialize : function ( obj ) {
      return (
        "?" +
        Object.keys(obj)
        .reduce(function(a, k) {
          let val = obj[k];
          let esArray = false;
          if (val instanceof Date) {
          val = val.toLocaleDateString("en");
          } else if (val instanceof Array) {
          esArray = true;
          let acumulador = "";
          for (let i = 0; i < val.length; i++) {
              acumulador += k + "%5B%5D=" + val[i];
              if (i != val.length - 1) {
              acumulador += "&";
              }
          }
          val = acumulador;
          a.push(val);
          }
          if (!esArray) a.push(k + "=" + encodeURIComponent(val));
          return a;
        }, [])
        .join("&")
      );
    },
  },
  mounted: function() {
    //Seteando fechas por defecto
    let desde = new Date();
    desde.setDate(desde.getDate() - 6);
    let hasta = new Date();
    this.form.fechaDesde = moment(desde).format("YYYY-MM-DD");
    this.form.fechaHasta = moment(hasta).format("YYYY-MM-DD");
    //Seteando bodegas
    if(this.administraTodasBodegas)
      this.optionsBodegas = [...this.bodegas];
    else{
      for(let i=0; i < this.bodegas.length; i++){
        if(this.idBodegaUsuario == this.bodegas[i].id){
          this.optionsBodegas.push(this.bodegas[i]);
          this.selectedBodega = this.bodegas[i];
          this.form.idBodega = this.bodegas[i].id;
          break;
        }
      }
    } 
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/ReporteArqueoCaja.vue